import { render, staticRenderFns } from "./SearchNexoTransactionHeader.vue?vue&type=template&id=53eca1ad&"
import script from "./SearchNexoTransactionHeader.vue?vue&type=script&lang=js&"
export * from "./SearchNexoTransactionHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchNexoTransactionHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports